import React from "react";
import PropTypes from "prop-types";
import radium from "radium";
import { Link } from "react-router";
import { color, media } from "rizzo-next/sass/settings.json";
import { gutter, span, percentage } from "../../utils/grid";

const containerWidth = span(8, "static");
const imageWidth = span(2, "static");
const contentWidth = span(6, "static");

const styles = {
  container: {
    withImage: {
      backgroundRepeat: "no-repeat",
      backgroundSize: "300px 400px",
      width: "300px",
      height: "400px",
      float: "left",
      margin: "4px 4px",
      position: "relative",
    },

    withoutImage: {
      backgroundColor: "#878F91",
      width: "300px",
      height: "400px",
      float: "left",
      margin: "4px 4px",
      position: "relative",
    },
  },

  image: {
    base: {
      position: "relative",
      width: percentage("78px", "335px"),

      [`@media (max-width: ${media.max["768"]})`]: {
        float: "right",
        marginTop: ".9rem",
      },

      [`@media (min-width: ${media.min["768"]})`]: {
        position: "absolute",
        right: 0,
        top: 0,
        width: percentage(imageWidth, containerWidth),
      },
    },

    img: {
      display: "block",
      float: "right",
    },
  },

  content: {
    base: {
      position: "absolute",
      bottom: "0",
      width: "inherit",
    },
  },

  info: {
    base: {
      overflow: "hidden",
    },
  },

  header: {
    base: {
      overflow: "hidden",

      [`@media (min-width: ${media.min["768"]})`]: {
        marginRight: percentage(gutter("static"), containerWidth),
        width: percentage(contentWidth, containerWidth),
      },
    },
  },

  title: {
    base: {
      color: color.white,
      float: "left",
      fontSize: "0.9rem",
      fontWeight: 600,
      letterSpacing: "-1px",
      lineHeight: 12 / 20,
      marginLeft: "5px",
      maxWidth: "76%",

      [`@media (min-width: ${media.min["768"]})`]: {
        fontSize: "1.5rem",
        lineHeight: 34 / 28,
        maxWidth: "100%",
        textOverflow: "ellipsis",
        overflow: "hidden",
        whiteSpace: "nowrap",
      },
    },
  },

  mentions: {
    base: {
      color: color.white,
      float: "left",
      fontSize: "0.8rem",
      lineHeight: 12 / 14,
      marginTop: ".9rem",
      width: percentage("242px", "335px"),
      marginLeft: "5px",
      fontWeight: 300,

      [`@media (min-width: ${media.min["768"]})`]: {
        fontSize: "1.2rem",
        lineHeight: 32 / 18,
        marginRight: percentage(gutter("static"), containerWidth),
        marginTop: "1.4rem",
        width: percentage(contentWidth, containerWidth),
      },
    },
  },
};

function CollectionListItem({
  title,
  slug,
  image,
  id,
  mentions,
}) {
  return (
    <div className="CollectionListItem" id={id} style={image.path ? [styles.container.withImage, { backgroundImage: `url(${image.path})` }] : styles.container.withoutImage}>
      <div className="CollectionListItem-content" style={styles.content.base}>
        <header className="CollectionListItem-header" style={styles.header.base}>

          <h2 className="CollectionListItem-title" style={styles.title.base}>
            <Link to={`${slug}`} style={{ color: "currentColor" }}>
              {title}
            </Link>
          </h2>
        </header>

        <div className="CollectionListItem-info" style={styles.info.base}>
          {mentions &&
            <div className="CollectionListItem-mentions" style={styles.mentions.base}>
              <div>
                {`${mentions.length} Items`}
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

CollectionListItem.propTypes = {
  /**
   * The name of the POI
   */
  title: PropTypes.string.isRequired,

  /**
   * The URL slug of the POI
   */
  slug: PropTypes.string.isRequired,

  /**
   * Image src for the POI; required keys are path and orientation
   */
  image: PropTypes.object,

  /**
   * Unique ID for item
   */
  id: PropTypes.string,
  /**
   * List of mentions
   */
  mentions: PropTypes.array,
};

CollectionListItem.defaultProps = {
  title: "",
  slug: "",
  image: {},
  id: "",
};

CollectionListItem.styles = styles;

export default radium(CollectionListItem);


// WEBPACK FOOTER //
// ./assets/pois/components/collectionListItem/index.jsx